module.exports = __webpack_public_path__ + "static/media/pin.875eabe5.svg";